<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <h1 class="text-center">Empowering Your Customer</h1>
                    <div class="line"></div>
                    <p class="text-center">Berpartisipasilah dalam inklusi keuangan digital dan kembangkan keuangan
                        pengguna<br>
                        dengan fitur-fitur yang diciptakan secara teliti dan menjawab kebutuhan pengguna.</p>

                    <v-tabs v-model="tab" background-color="transparent" color="basil" grow class="mt-10" show-arrows>
                        <!-- <v-tab v-for="item in items" :key="item">
                            {{ item }}
                        </v-tab> -->
                        <v-tab>
                            <v-img src="https://assets.invisee.com/statis/revamp/icon-rd.png" max-height="33" max-width="33" class="mr-1"></v-img> Reksa Dana
                        </v-tab>
                        <!-- <v-tab>
                            <v-img src="https://assets.invisee.com/statis/revamp/icon-emas.png" max-height="33" max-width="33" class="mr-1"></v-img> Emas
                        </v-tab> -->
                        <v-tab>
                            <v-img src="https://assets.invisee.com/statis/revamp/icon-sbn.png" max-height="33" max-width="33" class="mr-1"></v-img> SBN
                        </v-tab>
                        <v-tab>
                            <v-img src="https://assets.invisee.com/statis/revamp/icon-asuransi.png" max-height="33" max-width="33" class="mr-1"></v-img> Asuransi
                        </v-tab>
                        <v-tab>
                            <v-img src="https://assets.invisee.com/statis/revamp/icon-p2p.png" max-height="33" max-width="33" class="mr-1"></v-img> P2P Lending
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab" class="mt-10">
                        <v-tab-item v-for="(item, index) in items" :key="item">
                            <v-card flat>
                                <v-card-text class="text-center" v-if="index == 0 && item == 'Reksa Dana'">

                                    <h1>Kami telah bekerja sama dengan 13 manajer investasi terbaik Indonesia</h1>
                                    <div class="line"></div>
                                    <!-- <v-img src="https://assets.invisee.com/statis/revamp/main-rd.png"/> -->
                                    <v-img width="100%" src="/mi-rd.png"/>
                                    <!-- <v-container>
                                        <v-row justify="center">
                                            <v-col class="col-content" md="4">
                                                <v-img src="https://assets.invisee.com/statis/product/reksadana/insight.jpg"
                                                    max-height="280" max-width="280" contain class="marginauto" />
                                            </v-col>
                                            <v-col class="col-content" md="4">
                                                <v-img src="https://assets.invisee.com/statis/product/reksadana/bni-am.jpg"
                                                    max-height="280" max-width="280" contain class="marginauto" />
                                            </v-col>
                                            <v-col class="col-content" md="4">
                                                <v-img src="https://assets.invisee.com/statis/product/reksadana/syailendra.jpg"
                                                    max-height="280" max-width="280" contain class="marginauto" />
                                            </v-col>
                                            <v-col class="col-content" md="4">
                                                <v-img src="https://assets.invisee.com/statis/product/reksadana/danareksa.jpg"
                                                    max-height="280" max-width="280" contain class="marginauto" />
                                            </v-col>
                                            <v-col class="col-content" md="4">
                                                <v-img src="https://assets.invisee.com/statis/product/reksadana/bahana.png"
                                                    max-height="280" max-width="280" contain class="marginauto" />
                                            </v-col>
                                            <v-col class="col-content" md="4">
                                                <v-img src="https://assets.invisee.com/statis/product/reksadana/mandiri-investasi.jpg"
                                                    max-height="280" max-width="280" contain class="marginauto" />
                                            </v-col>
                                            <v-col class="col-content" md="4">
                                                <v-img src="https://assets.invisee.com/statis/product/reksadana/eastspring.png"
                                                    max-height="280" max-width="280" contain class="marginauto" />
                                            </v-col>
                                            <v-col class="col-content" md="4">
                                                <v-img src="https://assets.invisee.com/statis/product/reksadana/trimegah.jpg"
                                                    max-height="280" max-width="280" contain class="marginauto" />
                                            </v-col>
                                            <v-col class="col-content" md="4">
                                                <v-img src="https://assets.invisee.com/statis/product/reksadana/principal.png"
                                                    max-height="280" max-width="280" contain class="marginauto" />
                                            </v-col>
                                        </v-row>
                                    </v-container> -->
                                </v-card-text>
                                <!-- <v-card-text class="text-center" v-else-if="index == 1 && item == 'Emas'">

                                    <h1>Perusahaan emas berlisensi resmi dan lengkap di Indonesia</h1>
                                    <div class="line"></div>
                                    <v-container>
                                        <v-row justify="center">
                                            <v-col class="col-content" md="4">
                                                <v-img src="https://assets.invisee.com/statis/revamp/main-emas.png"
                                                    max-height="280" max-width="280" contain class="marginauto" />
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text> -->
                                 <v-card-text class="text-center" v-else-if="index == 1 && item == 'SBN'">
                                    <h2 class="header-sbn">Telah ditetapkan oleh Direktur Jendral Pembiayaan dan Pengelolaan Risiko (DJPPR) Kementerian Keuangan RI sebagai Mitra Distribusi dalam memasarkan produk Surat Berharga Negara Ritel online, yang mencakup Obligasi Ritel Indonesia, Saving Bonds Ritel, Sukuk Ritel dan Sukuk Tabungan</h2>
                                    <div class="line"></div>
                                    <!-- <v-img src="https://assets.invisee.com/statis/allproduct.jpg"/> -->
                                    <v-container>
                                        <v-row justify="center">
                                            <v-col style="padding-top: 0;">
                                                <h3 class="header-sbn">Kami bekerja sama dengan beberapa sub mitra distribusi, antara lain :</h3>
                                            </v-col>
                                        </v-row>
                                        <v-row justify="center">
                                            <v-col class="col-content" md="3">
                                                <a href="https://sbn-fundtasticplus.netlify.app/" target="_blank" style="color: black; text-decoration: none;">
                                                    <div style="min-height: 60px; justify-content: center; display: grid;">
                                                    <v-img src="https://assets.invisee.com/statis/logo.png"
                                                        max-height="100%" max-width="100%" contain style="" class="" />
                                                    </div>
                                                    <div style="margin-top: 10px;">FUNDtastic</div>
                                                </a>
                                            </v-col>
                                            <v-col class="col-content" md="3">
                                                <a href="https://sbn-valbury.netlify.app/" target="_blank" style="color: black; text-decoration: none;">
                                                    <div style="min-height: 60px; justify-content: center; display: grid;">
                                                    <v-img 
                                                    src="https://assets.invisee.com/statis/logo-kb-valbury-sekuritas.png"
                                                        max-height="100%" max-width="100%" contain class="" />
                                                    </div>
                                                    <div style="margin-top: 10px;">KB Valbury Sekuritas</div>
                                                </a>
                                            </v-col>
                                            <v-col class="col-content" md="3">
                                                <!-- <a href="https://sbn-valbury.netlify.app/" target="_blank" style="color: black; text-decoration: none;"> -->
                                                    <div style="min-height: 60px; text-align: center; justify-items: center; display: grid;">
                                                    <v-img 
                                                    src="/mirae-logo-indonesia.png"
                                                        max-height="100%" max-width="70%" contain class="" style="text-align: center;"/>
                                                    </div>
                                                    <div style="margin-top: 10px;">Mirae Asset Sekuritas</div>
                                                <!-- </a> -->
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                    <v-container>
                                        <v-row justify="center" style="padding-top: 0;">
                                            <v-col class="col-content" md="2">
                                                <v-img src="https://assets.invisee.com/statis/revamp/main-sbn.png"
                                                    max-height="100%" max-width="100%" contain class="marginauto" />
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-text class="text-center" v-else>
                                    <h1>Coming Soon</h1>
                                    <p style="font-size:20px; margin-top:30px">Kami sedang bekerja keras untuk menyediakan produk tersebut</p>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tab: null,
                items: [
                    "Reksa Dana", "SBN", "Asuransi", "P2P Lending"
                ],
                reksadanaProducts: [
                    "insight.jpg", "insight.jpg", "insight.jpg", "insight.jpg"
                ],
                text: 'Coming Soon',
            }
        },
    }
</script>

<style scoped>
    .v-tab {
        margin: 0 15px 6px;
        background-color: white;
        /* border: 1px solid #0082cc; */
        border-radius: 10px;
        /* border: 1px solid #888888; */
        padding: 10px 0;
        box-shadow: 0 2px 6px rgb(0 0 0 / 0.3);
        /* box-shadow: 2px 4px #888888; */
    }

    .v-tab:hover {
        border: 1px solid #0082cc;
    }

    .theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active) {
        color: #3a3a3a;
    }

    .v-tab.v-tab--active {
        /* background-color: #0082cc; */
        color: #0082cc;
        font-weight: bold;
        border: 1px solid #0082cc;
    }

    .v-tabs-slider {
        background-color: #f6f6f6 !important;
        height: 0;
    }

    .theme--light.v-card>.v-card__text {
        color: inherit;
    }

    .theme--light.v-sheet {
        background-color: rgba(248, 250, 250, 1);
    }

    .marginauto {
        margin: 35px auto;
    }

    .header-sbn{
        /* font-size: 22px; */
        line-height: 29px;
        /* font-weight: 400; */
        padding: 0 100px;
    }
</style>